// extracted by mini-css-extract-plugin
export default {"DurationBoxContainer":"_DurationBoxContainer--vxtNH","EmptyIcon":"_EmptyIcon--ksYTU","DurationBoxPadding":"_DurationBoxPadding--h8umT"};